import firebase from "firebase/app";

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyC2cbWXw6qrKB8LrwWPeqBg4Y_egXV56qk",
    authDomain: "creato-verse.firebaseapp.com",
    projectId: "creato-verse",
    storageBucket: "creato-verse.appspot.com",
    messagingSenderId: "432004471824",
    appId: "1:432004471824:web:74a75e2522483dd777be95"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

// DATABASE
var db = firebase.firestore();

const auth = firebase.auth();

// Get a reference to the storage service, which is used to create references in your storage bucket
var storage = firebase.storage();

export { db, storage, auth };
export default firebase;